// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
export const COPY = {
  learnMore: {
    label: 'Learn more',
    href: 'https://github.com/features/copilot',
  },
  signInCta: {
    label: 'Sign in',
    href: '#',
  },
  a11y: {
    toggleSidebarButton: 'Toggle sidebar',
  },
} as const
